export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-3xl font-bold text-teal-400 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Ecomez
            </h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Your trusted partner for cleaning and maintenance in Westbrook and Portland.
            </p>
            <div className="flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-full transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-full transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-full transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-left">
                  House Cleaning
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-left">
                  Office Cleaning
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-left">
                  Small Businesses
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-left">
                  Specialized Services
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('hero')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-left">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('areas')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-left">
                  Service Areas
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-left">
                  Testimonials
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-left">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400">
                <i className="ri-map-pin-line text-teal-400 flex-shrink-0 mt-1"></i>
                <span>Westbrook & Portland, ME</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-teal-400 flex-shrink-0 mt-1"></i>
                <a href="tel:+12076508754" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  (207) 650-8754
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-teal-400 flex-shrink-0 mt-1"></i>
                <a href="mailto:koumba212@gmail.com" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  koumba212@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400">
                <i className="ri-time-line text-teal-400 flex-shrink-0 mt-1"></i>
                <span>Mon-Sun: 7am-8pm</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © 2024 Ecomez. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}